import Patients from './Patients';
export default Patients;
